import { connect } from 'react-redux';
import {
  updateRepository,
  createRepositories,
  toggleModal,
  toggleSnackBar,
  deleteRepository,
  getRepositories,
  updateSensorAuthorization,
  getSensorAuthorizations,
  deleteSensorAuthorization
} from 'state/callers';
import { myAccountSelector } from 'state/selectors/account';
import {
  licenseSelector,
  isTeamLicenseSelector
} from 'state/selectors/license';
import { gitIntegrationsSelector } from 'state/selectors/sensors-authorizations';
import Repositories from './Repositories';
import { setIsProcessingRepos } from 'state/actions';
import { dispatchify, recall } from 'common/utils/utils';
import { shouldStopGetReposRecall } from 'common/services/http-polling-stopper';
import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';

const mapStateToProps = state => {
  const { repositories } = state;

  return {
    repositories,
    account: myAccountSelector(state),
    gitIntegrations: gitIntegrationsSelector(state),
    license: licenseSelector(state),
    isTeamLicense: isTeamLicenseSelector(state)
  };
};

const mapDispatchToProps = dispatch => ({
  ...dispatchify(dispatch, {
    deleteRepository,
    updateRepository,
    toggleModal,
    createRepositories,
    toggleSnackBar,
    getRepositories,
    setIsProcessingRepos,
    updateSensorAuthorization,
    getSensorAuthorizations,
    deleteSensorAuthorization
  }),
  ...recall(
    {
      ...dispatchify(dispatch, {
        // eslint-disable-next-line jsdoc/require-jsdoc
        getRepositories: () => getRepositories()
      })
    },
    shouldStopGetReposRecall,
    60
  )
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(Repositories, 'Git Settings'));
